const isEntityVisible = (stateAppliedFilters, entity) => {
  let visible = !stateAppliedFilters.length ? [true] : [];
  for (let stateAppliedFilter of stateAppliedFilters) {
    let condition;

    switch (stateAppliedFilter.type) {
      case 'bonus_massimo':
        condition = entity.bonus_massimo >= stateAppliedFilter.value;
        break;
      case 'playthrough':
        condition = entity.playthrough >= stateAppliedFilter.value;
        break;
      case 'puntata_minima_giochi_live':
        condition =
          entity.games_live &&
          !!entity.games_live.find(
            (e) => e.pivot.puntata_minima >= stateAppliedFilter.value
          );
        break;
      case 'puntata_minima_giochi_classici':
        condition =
          entity.games &&
          !!entity.games.find(
            (e) => e.pivot.puntata_minima >= stateAppliedFilter.value
          );
        break;

      default:
        condition =
          entity[stateAppliedFilter.type] &&
          stateAppliedFilter.value.every((v) =>
            entity[stateAppliedFilter.type].map((e) => e.id).includes(v)
          );
        break;
    }

    visible.push(condition);
  }
  return visible.every((e) => e);
};

module.exports = { isEntityVisible };
